var map = {
	"./activate-api": [
		"d886",
		"chunk-2d21ef48"
	],
	"./activate-api.md": [
		"d886",
		"chunk-2d21ef48"
	],
	"./api-key": [
		"9bde",
		"chunk-2d0f0680"
	],
	"./api-key.md": [
		"9bde",
		"chunk-2d0f0680"
	],
	"./api-version": [
		"70bb",
		"chunk-2d0d61cf"
	],
	"./api-version.md": [
		"70bb",
		"chunk-2d0d61cf"
	],
	"./append-responses": [
		"39dd",
		"chunk-2d0bb25c"
	],
	"./append-responses.md": [
		"39dd",
		"chunk-2d0bb25c"
	],
	"./background": [
		"d5b7",
		"chunk-2d21e91c"
	],
	"./background.md": [
		"d5b7",
		"chunk-2d21e91c"
	],
	"./blur-background": [
		"a835",
		"chunk-2d20918f"
	],
	"./blur-background.md": [
		"a835",
		"chunk-2d20918f"
	],
	"./collect-ip": [
		"1d73",
		"chunk-2d0b6565"
	],
	"./collect-ip.md": [
		"1d73",
		"chunk-2d0b6565"
	],
	"./color-palette": [
		"0355",
		"chunk-2d0a38d9"
	],
	"./color-palette.md": [
		"0355",
		"chunk-2d0a38d9"
	],
	"./countdown-notice": [
		"c431",
		"chunk-2d216b45"
	],
	"./countdown-notice.md": [
		"c431",
		"chunk-2d216b45"
	],
	"./data-format": [
		"75af",
		"chunk-2d0d7479"
	],
	"./data-format.md": [
		"75af",
		"chunk-2d0d7479"
	],
	"./embed-code": [
		"48f6",
		"chunk-2d0c230a"
	],
	"./embed-code.md": [
		"48f6",
		"chunk-2d0c230a"
	],
	"./endpoint-url": [
		"7795",
		"chunk-2d0d76f2"
	],
	"./endpoint-url.md": [
		"7795",
		"chunk-2d0d76f2"
	],
	"./external-id": [
		"5cb3",
		"chunk-2d0d3855"
	],
	"./external-id.md": [
		"5cb3",
		"chunk-2d0d3855"
	],
	"./font-size": [
		"49fe",
		"chunk-2d0c26fa"
	],
	"./font-size.md": [
		"49fe",
		"chunk-2d0c26fa"
	],
	"./geographical-reach": [
		"316e",
		"chunk-2d0b8ec3"
	],
	"./geographical-reach.md": [
		"316e",
		"chunk-2d0b8ec3"
	],
	"./handshake-key": [
		"b75d",
		"chunk-2d21029a"
	],
	"./handshake-key.md": [
		"b75d",
		"chunk-2d21029a"
	],
	"./hide-overlay": [
		"708e",
		"chunk-2d0d5cbc"
	],
	"./hide-overlay.md": [
		"708e",
		"chunk-2d0d5cbc"
	],
	"./hosted-link": [
		"84f2",
		"chunk-2d0de57e"
	],
	"./hosted-link.md": [
		"84f2",
		"chunk-2d0de57e"
	],
	"./iframe-notification": [
		"0fb6",
		"chunk-2d0afdc0"
	],
	"./iframe-notification.md": [
		"0fb6",
		"chunk-2d0afdc0"
	],
	"./include-pdf": [
		"ef65",
		"chunk-2d231016"
	],
	"./include-pdf.md": [
		"ef65",
		"chunk-2d231016"
	],
	"./include-response": [
		"aa06",
		"chunk-2d212b1c"
	],
	"./include-response.md": [
		"aa06",
		"chunk-2d212b1c"
	],
	"./instant-notifications": [
		"8b40",
		"chunk-2d0e8c1c"
	],
	"./instant-notifications.md": [
		"8b40",
		"chunk-2d0e8c1c"
	],
	"./kiosk-mode": [
		"1585",
		"chunk-2d0ab517"
	],
	"./kiosk-mode.md": [
		"1585",
		"chunk-2d0ab517"
	],
	"./logic": [
		"5330",
		"chunk-2d0c7e71"
	],
	"./logic.md": [
		"5330",
		"chunk-2d0c7e71"
	],
	"./mood": [
		"f3a6",
		"chunk-2d22ca38"
	],
	"./mood.md": [
		"f3a6",
		"chunk-2d22ca38"
	],
	"./multiple-participations": [
		"a766",
		"chunk-2d208e2c"
	],
	"./multiple-participations.md": [
		"a766",
		"chunk-2d208e2c"
	],
	"./participants-chart": [
		"d508",
		"chunk-2d21e30f"
	],
	"./participants-chart.md": [
		"d508",
		"chunk-2d21e30f"
	],
	"./percentages": [
		"493e",
		"chunk-2d0c20cd"
	],
	"./percentages.md": [
		"493e",
		"chunk-2d0c20cd"
	],
	"./promote-participation": [
		"892b",
		"chunk-2d0df227"
	],
	"./promote-participation.md": [
		"892b",
		"chunk-2d0df227"
	],
	"./promote-sharing": [
		"36ba",
		"chunk-2d0ba6d8"
	],
	"./promote-sharing.md": [
		"36ba",
		"chunk-2d0ba6d8"
	],
	"./public-results": [
		"308d",
		"chunk-2d0b8b3f"
	],
	"./public-results.md": [
		"308d",
		"chunk-2d0b8b3f"
	],
	"./reset-inactivity": [
		"a47e",
		"chunk-2d208337"
	],
	"./reset-inactivity.md": [
		"a47e",
		"chunk-2d208337"
	],
	"./restart-timer": [
		"e226",
		"chunk-2d224c67"
	],
	"./restart-timer.md": [
		"e226",
		"chunk-2d224c67"
	],
	"./right-to-left": [
		"5b2e",
		"chunk-2d0d2ef6"
	],
	"./right-to-left.md": [
		"5b2e",
		"chunk-2d0d2ef6"
	],
	"./social-sharing": [
		"82c5",
		"chunk-2d0ddda2"
	],
	"./social-sharing.md": [
		"82c5",
		"chunk-2d0ddda2"
	],
	"./summary-notifications": [
		"ce7e",
		"chunk-2d2223e6"
	],
	"./summary-notifications.md": [
		"ce7e",
		"chunk-2d2223e6"
	],
	"./thanks-timer": [
		"66c0",
		"chunk-2d0d03e3"
	],
	"./thanks-timer.md": [
		"66c0",
		"chunk-2d0d03e3"
	],
	"./themes": [
		"dbb3",
		"chunk-2d229205"
	],
	"./themes.md": [
		"dbb3",
		"chunk-2d229205"
	],
	"./transparent-iframe": [
		"6e44",
		"chunk-2d0daea5"
	],
	"./transparent-iframe.md": [
		"6e44",
		"chunk-2d0daea5"
	],
	"./trigger-on": [
		"886f",
		"chunk-2d0deee6"
	],
	"./trigger-on.md": [
		"886f",
		"chunk-2d0deee6"
	],
	"./typography": [
		"4720",
		"chunk-2d0c18f7"
	],
	"./typography.md": [
		"4720",
		"chunk-2d0c18f7"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "883e";
module.exports = webpackAsyncContext;